import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestWorkHistories = date => ({
  type: ActionTypes.REQUEST_WORK_HISTORY_STATUS,
  date
})

export const receiveWorkHistories = (params, json) => ({
  type: ActionTypes.RECEIVE_WORK_HISTORY_STATUS,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

export const clearWorkHistories = () => ({
  type: ActionTypes.CLEAR_WORK_HISTORY_STATUS,
})

const doFetchWorkHistories = params => async dispatch => {
  dispatch(requestWorkHistories(params))

  const data = {
        "process_type": "getDataHistoryStatusList",
        "date_start": params.startDate,
        "date_end": params.endDate,
        "mac_add": params.mac_add,
        // "offset": params.offset,
        // "limit": params.limit
  };

  try {
    const json = await postApi(data);
    dispatch(receiveWorkHistories(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   dispatch(receiveWorkHistories(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchWorkHistories = params => (dispatch, getState) => {
  return dispatch(doFetchWorkHistories(params))
}

export const clearWorkHistoriesStatus = params => (dispatch) => {
  return dispatch(clearWorkHistories())
}